import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-drag-and-drop',
  templateUrl: './drag-and-drop.component.html',
  styleUrls: ['./drag-and-drop.component.css']
})
export class DragAndDropComponent implements AfterViewInit, OnDestroy {

  // attributes
  datagrid1;
  datagrid2;
  gridId1 = 'SBGridArea1';
  gridId2 = 'SBGridArea2';
  gridStyle = {
    width: '100%',
    height: '580px'
  };
  leftAlignStyle = {
    display: 'inline-block',
    width: '49%'
  }
  tempData = [];

  // methods

  constructor() { }

  ngAfterViewInit(): void {
    const gridProp1 = {
      parentid: this.gridId1,
      id: 'datagrid1',
      jsonref:'grid_data12',
      backcoloralternate: '#efefef',
      columns: [
        {caption : ['PO No.'],   ref : 'poNo',    width : '20%',  style : 'text-align:left',    type : 'input'},
        {caption : ['Season'],    ref : 'season',        width : '15%',  style : 'text-align:left',    type : 'input'},
        {caption : ['SKU'],    ref : 'sku',      width : '20%',  style : 'text-align:center',    type : 'input'},
        {caption : ['Order Item'],    ref : 'orderItem',      width : '20%',  style : 'text-align:center',    type : 'input'},
        {caption : ['Target Country'],    ref : 'targetCountry',      width : '20%',  style : 'text-align:center',    type : 'input'}
      ],
      rowheight: '26',
      rowheader: 'update',
    };
    const gridProp2 = {
      parentid: this.gridId2,
      id: 'datagrid2',
      jsonref: this.tempData,
      backcoloralternate: '#efefef',
      columns: [
        {caption : ['PO No.'],   ref : 'poNo',    width : '20%',  style : 'text-align:left',    type : 'input'},
        {caption : ['Season'],    ref : 'season',        width : '15%',  style : 'text-align:left',    type : 'input'},
        {caption : ['SKU'],    ref : 'sku',      width : '20%',  style : 'text-align:center',    type : 'input'},
        {caption : ['Order Item'],    ref : 'orderItem',      width : '20%',  style : 'text-align:center',    type : 'input'},
        {caption : ['Target Country'],    ref : 'targetCountry',      width : '20%',  style : 'text-align:center',    type : 'input'}
      ],
      rowheight: '26',
      rowheader: 'update',
    };
    window['datagrid1'] = this.datagrid1 = _SBGrid.create(gridProp1);
    window['datagrid2'] = this.datagrid2 = _SBGrid.create(gridProp2);

    this.datagrid1.setDnD({target : 'datagrid2', type : 'move', position : 'insert', stylesync : false});
    this.datagrid2.setDnD({target : 'datagrid1', type : 'move', position : 'insert', stylesync : false});
  }

  ngOnDestroy(): void {
    _SBGrid.destroy(this.datagrid1.getID());
    _SBGrid.destroy(this.datagrid2.getID());
  }

}
